import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './contexts/AuthContext';
import { MainLayout } from './components/Layout/MainLayout';
import { Dashboard } from './pages/Dashboard';
import { Tav3Dashboard } from './pages/Tav3Dashboard';
import { Tav3PublicDashboard } from './pages/Tav3PublicDashboard';
import { BasicasPage } from './pages/BasicasPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ContextSelectionPage from './pages/ContextSelectionPage';
import ModuloPage from './pages/ModuloPage';
import FluxosPage from './pages/FluxosPage';
import MarcasPage from './pages/tabelas/MarcasPage';
import FamiliasPage from './pages/tabelas/FamiliasPage';
import LinhasPage from './pages/tabelas/LinhasPage';
import MercadosPage from './pages/tabelas/MercadosPage';
import RegioesPage from './pages/tabelas/RegioesPage';
import UnidadesPage from './pages/tabelas/UnidadesPage';
import ColecoesPage from './pages/tabelas/ColecoesPage';
import CoresPage from './pages/tabelas/CoresPage';
import TamanhosPage from './pages/tabelas/TamanhosPage';
import TiposDocumentoPage from './pages/tabelas/TiposDocumentoPage';
import CategoriasPage from './pages/tabelas/CategoriasPage';
import AppearancePage from './pages/AppearancePage';
import AreasFuncionaisPage from './pages/AreasFuncionaisPage';
import CopiarPadroesTenantPage from './pages/admin/CopiarPadroesTenantPage';
import { EstoqueDashboard } from './pages/EstoqueDashboard';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  // Mostrar loading apenas se há token sendo verificado
  const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
  const shouldShowLoading = isLoading && !!token;

  if (shouldShowLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      {/* Rotas públicas */}
      <Route
        path="/login"
        element={isAuthenticated && !isLoading ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordPage />}
      />

      {/* Seleção de contexto (empresa) — protegida, mas fora do MainLayout */}
      <Route
        path="/context-selection"
        element={isAuthenticated ? <ContextSelectionPage /> : <Navigate to="/login" replace />}
      />

      {/* TAV3 Dashboard - acesso público para testes */}
      <Route path="/dashboards/tav3/test" element={<Tav3PublicDashboard />} />

      {/* Dashboard de Estoque - acesso por token na URL (integrações/ERP), fora do guard de sessão */}
      <Route path="/dashboards/estoque" element={<EstoqueDashboard />} />

      {/* Rotas protegidas com layout completo */}
      <Route
        path="/"
        element={isAuthenticated ? <MainLayout /> : <Navigate to="/login" replace />}
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard"   element={<Dashboard />} />
        <Route path="fluxos"      element={<FluxosPage />} />
        <Route path="dashboards/tav3" element={<Tav3Dashboard />} />
        <Route path="estoque" element={<EstoqueDashboard />} />
        <Route path="basicas"     element={<BasicasPage />} />
        <Route path="funcionais"  element={<BasicasPage />} />
        <Route path="reservadas"  element={<BasicasPage />} />
        <Route path="aparencia"   element={<AppearancePage />} />
        <Route path="appearance"  element={<AppearancePage />} />
        <Route path="config/aparencia" element={<AppearancePage />} />
        <Route path="config/appearance" element={<AppearancePage />} />
        <Route path="admin/copiar-padroes" element={<CopiarPadroesTenantPage />} />
        {/* Áreas Funcionais — operação pelo admin do grupo/empresa (escopo por vínculo no backend) */}
        <Route path="areas-funcionais" element={<AreasFuncionaisPage />} />

        {/* Módulos ThorJava: nível 0 (Tabelas, Vendas, ...) */}
        <Route path="modulo/*" element={<ModuloPage />} />

        {/* Sub-grupos ThorJava: qualquer nível hierarquicamente navegavel */}
        <Route path="g/*" element={<ModuloPage />} />

        {/* Telas ThorJava específicas — antes do catch-all /t/* */}
        <Route path="t/marcas"     element={<MarcasPage />} />
        <Route path="t/familias"   element={<FamiliasPage />} />
        <Route path="t/linhas"     element={<LinhasPage />} />
        <Route path="t/mercados"   element={<MercadosPage />} />
        <Route path="t/regioes"    element={<RegioesPage />} />
        <Route path="t/unidades"   element={<UnidadesPage />} />
        <Route path="t/unids"      element={<Navigate to="/t/unidades" replace />} />
        <Route path="t/Unids"      element={<Navigate to="/t/unidades" replace />} />
        <Route path="t/colecoes"   element={<ColecoesPage />} />
        <Route path="t/cores"      element={<CoresPage />} />
        <Route path="t/tamanhos"   element={<TamanhosPage />} />
        <Route path="t/tipos-documento" element={<TiposDocumentoPage />} />
        <Route path="t/categorias" element={<CategoriasPage />} />

        {/* Telas ThorJava genéricas: folhas com cards ou placeholder */}
        <Route path="t/*" element={<ModuloPage />} />


        {/* Catch-all */}
        <Route path="*" element={
          <div className="flex items-center justify-center h-full text-slate-400 p-6">
            Módulo em desenvolvimento.
          </div>
        } />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
